// const baseURL = "http://localhost:5001"; 

// const baseURL = "https://friendserp.newfriendsjewellers.com:8085";


const baseURL ="https://friendserp2.newfriendsjewellers.com:9095";


// const baseURL ="https://friendsgoldsmith.newfriendsjewellers.com:9096";


export default baseURL;